import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridAngular } from 'ag-grid-angular';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DirectivesModule } from '../../../../components/directives.module';
import { RegimenListComponent } from './list.component';

const ROUTES: Routes = [
  { path: '', component: RegimenListComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    DirectivesModule,
    RouterModule.forChild(ROUTES),
    AgGridAngular,
  ],
  declarations: [RegimenListComponent],
  exports: [RegimenListComponent],
})
export class RegimenListModule {}
